import React from 'react'; 
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {RootState, useAppDispatch, useAppSelector} from "../../../state/state.tsx";
import {closeModal} from "../../../state/ModalSlice/ModalSlice.ts";
import {IconButton} from "@mui/material";
import QRCode from "react-qr-code";
import CloseIcon from "@mui/icons-material/Close";
import html2canvas from 'html2canvas';
import {Download} from "@mui/icons-material";
import {collection, getDocs, query, where} from "firebase/firestore";
import { db } from '../../../Config/firebase.ts';

export default function QRCodeModal() {

    const Dispatch = useAppDispatch();
    const ServiceProviderProfile = useAppSelector((state: RootState) => state.userSliceV2.data)
    const serviceProviderId = ServiceProviderProfile?.uid;
    const open = useAppSelector((state: RootState) => state.ModalSlice.QRCodeModalOpen);
    const [customBrandingNumber,setCustomBrandingNumber] = React.useState("916363860121")

    // function to add customBrandingNumberWhatsapp when the modal is opened

    const checkCustomBrandingExists = async () => {
        try {
            // Only proceed if we have a valid serviceProviderId
            if (!serviceProviderId) {
                console.warn('No service provider ID available');
                setCustomBrandingNumber("916363860121");
                return;
            }

            const querySnapshot = await getDocs(
                query(
                    collection(db, 'CustomBranding'),
                    where('providerReference', '==', serviceProviderId)
                )
            );

            if (!querySnapshot.empty) {
                const firstDoc = querySnapshot.docs[0];
                const data = firstDoc.data();
                setCustomBrandingNumber(data.customNumber || "916363860121");
            } else {
                setCustomBrandingNumber("916363860121");
            }
        } catch (error) {
            console.error('Error fetching custom branding:', error);
            setCustomBrandingNumber("916363860121");
        }
    };

    React.useEffect(()=>{
        if (open) {
            checkCustomBrandingExists()
        }
    },[open, serviceProviderId])

    function handleClose() {
        Dispatch(closeModal("QRCodeModalOpen"))
    }

    // QR Code

    const handleCaptureClick = async () => {

        const QRCodeElement =
            document.querySelector<HTMLElement>('#QRCode');
        if (!QRCodeElement) return;


        const canvas = await html2canvas(QRCodeElement);
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = 'QRCode.png';
        // Append the link to the body (necessary for some browsers)
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (<React.Fragment>

        <Dialog
            sx={{
                padding: 0,
                '& .MuiPaper-root': {
                    borderRadius: '10px',
                },
            }}
            maxWidth="md"
            open={open}
            PaperProps={{
                component: 'div',
            }}
        >
            <DialogContent sx={{paddingX: "60px", paddingY: "50px"}} className={"bg-white"}>
                <div className={"header pb-[10px] min-w-[550px]"}>
                    <p className={"text-cf_heading font-[600] "}>QR CODE</p>
                    <p className={"text-cf_small font-[400] "}>Provide this QR code to your customers to grant them
                        direct access to your business.</p>
                </div>

                <div className={"absolute right-4 top-4"}><IconButton onClick={handleClose}>
                    <CloseIcon/>
                </IconButton></div>

                <div id={"QRCode"} className={"pb-4 py-2 flex flex-col items-center w-full bg-white"}>
                    <div>
                        <p className={"text-cf_heading font-semibold mb-4"}>{ServiceProviderProfile?.businessProfile?.businessName|| ""}</p>

                    </div>
                    <div className={"bg-cc_brand p-4 rounded-xl flex flex-col items-center"}>
                        <div className={" p-2 bg-white"}>
                            <QRCode
                                size={40}
                                style={{height: "auto", width: "200px"}}
                                value={`https://wa.me/${customBrandingNumber}?text=I%20want%20to%20inquire%20about%20${ServiceProviderProfile?.businessProfile?.businessName}(${serviceProviderId})`}

                                viewBox={`0 0 256 256`}
                            />
                        </div>
                        <div className={"font-semibold text-white flex flex-col items-center mt-2"}>
                            <p className={"text-cf_subHeading "}>
                                SCAN IT
                            </p>
                            <p> & Get to know us.</p>
                        </div>


                    </div>
                    <p className={"mt-2 font-semibold"}> 
                        Ph : {ServiceProviderProfile?.phone_number||""}
                    </p>
                    
                    <div className={"mt-1"}>
                        Managed by <span className={"text-cc_brand font-semibold"}>www.hosaksham.com</span>
                    </div>

                </div>

                <div className={"flex gap-2 pt-4"}>

                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            handleCaptureClick()
                        }}
                        className={"w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center gap-2"}>
                        <Download/> Download QR Code.
                    </button>

                </div>
            </DialogContent>

        </Dialog>

    </React.Fragment>);
}